module.exports = __webpack_public_path__ + "img/luxuryyacht_main_03.b11d64c1.jpg";